import { requestBuilder } from '../../http/RequestBuilder';
import type { InterventionProfile } from '../types/InterventionTypes';
import type {
    AdminCreateLnpRequest,
    AdminCreateLnpResponse,
} from '../types/LnpTypes';

/**
 * Get all investment profiles requiring manual intervention
 * @example GET /api/admin/investments/intervention-profiles
 */
export const useGetInterventionProfiles = requestBuilder.query<
    InterventionProfile[],
    Record<string, never>
>({
    endpoint: '/api/admin/investments/intervention-profiles',
    queryKey: 'admin/investments/intervention-profiles',
});

/**
 * Create a Legal Natural Person (LNP) for a user in Apex Clearing
 * @example POST /api/admin/investments/lnp
 */
export const useCreateLnp = requestBuilder.mutation<
    AdminCreateLnpResponse,
    AdminCreateLnpRequest
>({
    endpoint: '/api/admin/investments/lnp',
    method: 'POST',
});

/**
 * Resolve (clear) manual intervention for a user who has an LNP.
 * @example PATCH /api/admin/investments/intervention-profiles/:userId/resolve
 */
export const useResolveIntervention = requestBuilder.mutation<
    { userId: string; manualInterventionStatus: string },
    undefined,
    { userId: string }
>({
    endpoint: (urlParams) =>
        `/api/admin/investments/intervention-profiles/${urlParams.userId}/resolve`,
    method: 'PATCH',
});
